import { BenefitCtaConfig, BENEFITS_CTA_CONFIG } from 'luxPlus/constants/benefits'

export const isActiveMemberWithSubscriptionTier = (result: App.MemberSubscriptionItem) => result.tier !== 'free_preview' && result.status !== 'CONFIRMED_AWAITING_PAYMENT'

/**
 * TODO - replace this with the actual implementation from svc-insurance
 */
export const getLuxPlusInsuranceDiscount = (basePrice: number = 0): number => parseFloat((basePrice * 0.6).toFixed(2))

/**
 * Configuration for the benefits CTA links
 */
export function getBenefitCtaConfig(type: App.LuxPlusBenefitType): BenefitCtaConfig {
  return BENEFITS_CTA_CONFIG[type]
}
